import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "src/app/core/service/auth.service";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
})
export class ColaboratorService {
    handleError: any;
    headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient) {
    }

    create(data: any) {
        return this.http.post<any>(environment.API_URL + `/api/colaborator`, data, { headers: this.headers });
    }

    getAll() {
        return this.http.get<any>(environment.API_URL + `/api/colaborator`);
    }

    get(colaboratorId: number) {
        let params = new HttpParams();
        params = params.appendAll({
            relations: 'user,professionalCategory,contractType,schedule,photo'
        });

        return this.http.get<any>(environment.API_URL + `/api/colaborator/${colaboratorId}`, { params });
    }

    getColaboratorsOfTeam(colaboratorId: number, owner: boolean) {
        let params = new HttpParams();
        params = params.appendAll({
            relations: 'user,professionalCategory,contractType,schedule'
        });

        params = params.append('query[colaboratorId]', colaboratorId);
        params = params.append('query[owner]', owner);

        return this.http.get<any>(environment.API_URL + `/api/colaborator/team`, { params });
    }

    getColaboratorOfUser(userId: number) {
        let params = new HttpParams();
        params = params.appendAll({
            relations: 'user,professionalCategory,contractType,schedule'
        });

        params = params.append('query[userId]', userId);

        return this.http.get<any>(environment.API_URL + `/api/colaborator/user`, { params });
    }

    getColaboratorssByPage(pageSize: number, page: number, search?: string) {
        let params = new HttpParams();
        params = params.appendAll({
            relations: 'user,professionalCategory,contractType,schedule',
            pageSize,
            page,
            sort: 'id:DESC'
        });

        if (search && search !== '') {
            params = params.appendAll({
                searchFields: 'user.firstName,user.lastName,professionalCategory.designation,contractType.designation,schedule.designation',
                search
            });
        }

        return this.http.get<any[]>(`${environment.API_URL}/api/colaborator`, { params });
    }

    update(colaboratorId: number, data: any) {
        return this.http.patch<any>(environment.API_URL + `/api/colaborator/${colaboratorId}`, data, { headers: this.headers });
    }

    updateColaboratorGeneralData(colaboratorId: number, data: any) {
        return this.http.patch<any>(environment.API_URL + `/api/colaborator/${colaboratorId}/general-data`, data, { headers: this.headers });
    }

    updateColaboratorProfessionalSituation(colaboratorId: number, data: any) {
        return this.http.patch<any>(environment.API_URL + `/api/colaborator/${colaboratorId}/professional-situation`, data, { headers: this.headers });
    }

    manage(colaboratorId: number, data: any) {
        return this.http.patch<any>(environment.API_URL + `/api/absence/colaborator/${colaboratorId}`, data, { headers: this.headers });
    }

    delete(colaboratorId: number) {
        return this.http.delete<any>(environment.API_URL + `/api/colaborator/${colaboratorId}`);
    }
}